// A button's busy state (#1694): while its action runs the button is disabled, says aria-busy, and shows a small
// spinner before its label, so a second click does nothing. `others` are disabled with it (the rest of a button
// group, a panel's other choices). A click on a busy button runs nothing. The button may be redrawn while the action
// runs; restoring a detached one is harmless.
const SPINNER = `<span data-busy-spinner aria-hidden="true" class="mr-1.5 inline-block size-3.5 shrink-0 animate-spin rounded-full border-2 border-current border-t-transparent align-middle"></span>`;

export async function withBusy(button, action, { others = [] } = {}) {
  if (!button) return action();
  if (button.getAttribute("aria-busy") === "true") return undefined;
  const all = [button, ...others].filter((b) => b && b !== button);
  all.unshift(button);
  const wasDisabled = all.map((b) => b.disabled);
  all.forEach((b) => { b.disabled = true; });
  button.setAttribute("aria-busy", "true");
  button.insertAdjacentHTML("afterbegin", SPINNER);
  try {
    return await action();
  } finally {
    button.querySelector("[data-busy-spinner]")?.remove();
    button.removeAttribute("aria-busy");
    all.forEach((b, i) => { b.disabled = wasDisabled[i]; });
  }
}
